"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PerlinNoise = function PerlinNoise() {
  var rand = arguments.length <= 0 || arguments[0] === undefined ? Math.random : arguments[0];

  _classCallCheck(this, PerlinNoise);

  var perm = new Int8Array(257);

  for (var i = 0; i < 256; i++) {
    perm[i] = i & 1 ? 1 : -1;
  }

  for (var i = 0; i < 256; i++) {
    var j = rand() * 4294967296 & 255;

    var _ref = [perm[j], perm[i]];
    perm[i] = _ref[0];
    perm[j] = _ref[1];
  }
  perm[256] = perm[0];

  function noise1d(x) {
    var x0 = x | 0;
    var x1 = x - x0;
    var xi = x0 & 255;
    var fx = (3 - 2 * x1) * x1 * x1;
    var a = x1 * perm[xi];
    var b = (x1 - 1) * perm[xi + 1];

    return a + fx * (b - a);
  }

  function noise(x) {
    var sum = 0;

    sum += (1 + noise1d(x)) * 0.25;
    sum += (1 + noise1d(x * 2)) * 0.125;
    sum += (1 + noise1d(x * 4)) * 0.0625;
    sum += (1 + noise1d(x * 8)) * 0.03125;

    return sum;
  }

  this.noise = noise;
};

exports["default"] = PerlinNoise;
module.exports = exports["default"];